import React, { useState } from 'react';
import { DiaryLessonCard } from '@/components/DiaryLessonCard';
import { DiaryNotes } from '@/components/DiaryNotes';
import { DiaryChangesCard } from '@/components/DiaryTable/DiaryChangesCard';
import { DiaryEmptyDay } from '@/components/DiaryTable/DiaryEmptyDay';
import { LessonDetailsModal } from '@/components/LessonDetailsModal';
import { LessonDetailsMode } from '@/types/components';
import type { DiaryEntry, DiaryLesson } from '@/types/diary';
import { countChangedLessons, hasDiaryContent } from '@/utils/diary';

interface Props {
  entry: DiaryEntry | undefined;
}

export const DiaryDayLessons: React.FC<Props> = ({ entry }) => {
  const [openLesson, setOpenLesson] = useState<DiaryLesson>();

  const lessons = entry?.lessons ?? [];
  const isEmptyDay = !entry || !hasDiaryContent(entry);
  const changedLessonCount = countChangedLessons(lessons);

  return (
    <>
      {isEmptyDay && <DiaryEmptyDay />}
      {changedLessonCount > 0 && (
        <DiaryChangesCard changedLessonCount={changedLessonCount} />
      )}
      <div className="flex flex-col gap-2">
        {lessons.map((lesson, index) => (
          <DiaryLessonCard
            key={`${lesson.className}-${index}`}
            lesson={lesson}
            onClick={() => setOpenLesson(lesson)}
          />
        ))}
      </div>

      <DiaryNotes
        behaviourEntries={entry?.behaviourEntries ?? []}
        notes={entry?.notes ?? []}
      />

      {entry && openLesson && (
        <LessonDetailsModal
          mode={LessonDetailsMode.Lesson}
          lesson={openLesson}
          date={entry.date}
          onClose={() => setOpenLesson(undefined)}
        />
      )}
    </>
  );
};
